import axios from "axios";
import cookies from "vue-cookies";
import router from '../../../router/router'

const API_BASE_URL_STORAGE_KEY = "app_api_base_url";

const normalizeBaseUrl = (raw) => {
  if (typeof raw !== "string") return null;

  const trimmed = raw.trim();
  if (!trimmed || trimmed === "undefined" || trimmed === "null") return null;

  try {
    const parsed = new URL(trimmed, window.location.origin);
    return `${parsed.origin}${parsed.pathname}`.replace(/\/+$/, "");
  } catch {
    return null;
  }
};

const readStoredBaseUrl = () => {
  try {
    return normalizeBaseUrl(localStorage.getItem(API_BASE_URL_STORAGE_KEY));
  } catch {
    return null;
  }
};

const writeStoredBaseUrl = (url) => {
  try {
    localStorage.setItem(API_BASE_URL_STORAGE_KEY, url);
  } catch {
    // ignore storage errors
  }
};

const runtimeBaseUrl = normalizeBaseUrl(window.runtimeConfig?.VITE_APP_API);
const storedBaseUrl = readStoredBaseUrl();

if (runtimeBaseUrl) {
  writeStoredBaseUrl(runtimeBaseUrl);
}

const resolvedBaseUrl = !navigator.onLine
  ? (storedBaseUrl || runtimeBaseUrl || window.location.origin)
  : (runtimeBaseUrl || storedBaseUrl || window.location.origin);

axios.defaults.baseURL = `${resolvedBaseUrl}/api`;
axios.defaults.headers.common["accept-language"] = "th";

let _loaderRef = null;
export function registerLoaderRef(vueRef) {
  _loaderRef = vueRef;
}

// ====== loader state ======
let active = 0;
let hideTimer = null;
let lastShownAt = 0;

const HIDE_DELAY_MS = 600;
const MIN_SHOW_MS = 400;

// ====== helper ทำงานจริง ======
function showNow() {
  clearTimeout(hideTimer);
  lastShownAt = Date.now();
  try {
    _loaderRef.value.showLoader?.();
  } catch (e) {
    console.warn("[loader] showLoader() error:", e);
  }
}
function hideNow() {
  clearTimeout(hideTimer);
  try {
    _loaderRef.value.hideLoader?.();
  } catch (e) {
    console.warn("[loader] hideLoader() error:", e);
  }
}
function scheduleHide() {
  const elapsed = Date.now() - lastShownAt;
  const wait = Math.max(MIN_SHOW_MS - elapsed, 0) + HIDE_DELAY_MS;
  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => hideNow(), wait);
}
function inc() {
  active += 1;
  if (active === 1) showNow();
}
function dec() {
  if (active > 0) active -= 1;
  if (active === 0) scheduleHide();
}

// 👉 flag ภายใน config เพื่อรู้ว่า request นี้ใช้ loader หรือไม่
const LOADER_FLAG = Symbol("useGlobalLoader");

function isTrueLike(v) {
  if (v === true) return true;
  if (typeof v === "string") {
    const s = v.trim().toLowerCase();
    return s === "true" || s === "1" || s === "yes" || s === "on";
  }
  return false;
}
function wantsNoLoader(config) {
  const cfg = config || {};
  const headers = cfg.headers || {};
  const headerRaw =
    headers["X-No-Loader"] ?? headers["x-no-loader"] ?? headers["X-no-loader"];
  return (
    isTrueLike(cfg.noLoader) ||
    isTrueLike(cfg?.meta?.noLoader) ||
    isTrueLike(headerRaw)
  );
}

// ====== กัน interceptors ผูกซ้ำใน dev/HMR ======
if (!axios.__loaderInterceptorsAdded) {
  axios.__loaderInterceptorsAdded = true;

  axios.interceptors.request.use(
    (config) => {
      // ใส่ token
      const token = cookies.get("token");
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      } else if (config.headers && "Authorization" in config.headers) {
        delete config.headers.Authorization;
      }

      // ตัดสินใจใช้ loader
      const useLoader = !wantsNoLoader(config);

      // ลบ header คุม loader ออกจาก request จริง
      if (config.headers) {
        delete config.headers["X-No-Loader"];
        delete config.headers["x-no-loader"];
        delete config.headers["X-no-loader"];
      }

      // เก็บ flag ไว้
      config[LOADER_FLAG] = useLoader;

      if (useLoader) inc();
      return config;
    },
    (error) => {
      console.log("[axios][request][error]", error?.message);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      if (response?.config?.[LOADER_FLAG]) dec();
      return response;
    },
    (error) => {
      if (error?.config?.[LOADER_FLAG]) dec();

      if (error?.response?.status === 401) {
        cookies.remove("token");
        // window.location.replace(`${window.location.hostname}/login`);
        router.replace('/login');
      }
      return Promise.reject(error);
    }
  );
}

export default axios;
